import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import Submitable, { SubmitEventListener } from '@philips-emr/tws-core/lib/component/types/submitable';
import { isEnumValid } from '@philips-emr/tws-utils';

import { BiometryStatus } from './constants';

class BiometryAPI extends ComponentAPI implements Submitable {

  /** @event */
  @AwesomeEvent
  onBeforeCancel = new SubmitEventListener();

  /** @event */
  @AwesomeEvent
  onCancel = new SubmitEventListener();

  /** @event */
  @AwesomeEvent
  onBeforeSubmit = new SubmitEventListener();

  /** @event */
  @AwesomeEvent
  onSubmit = new SubmitEventListener();

  submit(): void {
    this.onSubmit.fire();
  }

  cancel(): void {
    this.onCancel.fire();
  }

  getCancelExpression(): string {
    return this.state.cancelExpression;
  }

  setCancelExpression(cancelExpression: string): void {
    this.setState({ cancelExpression });
  }

  getCaptureExpression(): string {
    return this.state.captureExpression;
  }

  setCaptureExpression(captureExpression: string): void {
    this.setState({ captureExpression });
  }

  getNotFoundExpression(): string {
    return this.state.notFoundExpression;
  }

  setNotFoundExpression(notFoundExpression: string): void {
    this.setState({ notFoundExpression });
  }

  getRemoveExpression(): string {
    return this.state.removeExpression;
  }

  setRemoveExpression(removeExpression: string): void {
    this.setState({ removeExpression });
  }

  getRetryExpression(): string {
    return this.state.retryExpression;
  }

  setRetryExpression(retryExpression: string): void {
    this.setState({ retryExpression });
  }

  getStatus(): BiometryStatus {
    return this.state.status;
  }

  setStatus(status: BiometryStatus): void {
    if (isEnumValid(BiometryStatus, status)) {
      this.setState({ status });
    }
  }

  getTouchExpression(): string {
    return this.state.touchExpression;
  }

  setTouchExpression(touchExpression: string): void {
    this.setState({ touchExpression });
  }
}

export default BiometryAPI;
